<script>
import "@/assets/css/reset.min.css"
import "@/assets/js/rem"
import Footer from './components/footer.vue'
import Header from './components/header.vue'
import CookiesRule from './components/cookiesRule.vue'
import CustomerService from './components/customerService.vue'
export default {
    name: 'app',
    components: {
        Header,
        Footer,
        CookiesRule,
        CustomerService
        
    },
    mounted(){
        if(localStorage.getItem('token')){
            this.$store.dispatch('getUserinfo');
        }
        // this.$router.onReady(() => {
        //     console.log(this.$route.query)
        // })
    },
    watch: {
        "$route.query.utm_source": {
            handler: function( utm_source ){
                if(utm_source){
                    // console.log(utm_source)
                }
            },
            immediate: true
        }
    }
}
</script>

<template>
    <div id="app" :class="{is_home: $route.path == '/'}">
        <Header/>
        <keep-alive include="Products">
            <router-view></router-view>
        </keep-alive>
        <Footer/>
        <!-- <CookiesRule/> -->
        <CustomerService/>
    </div>
</template>

<style lang="scss">
@font-face {
    font-family: 'bpg_glaho';
    // src: url('~@/assets/font/bpg_glaho_v6_print.ttf') format("truetype");
    src: url('~@/assets/font/HaasGrotDispR-45Light.ttf') format("truetype");
    font-style: normal;
    font-weight: normal;
}
#app{
    // font-family:Arial,Helvetica,sans-serif;
    font-family: 'bpg_glaho';
    font-size: 12px;
    // overflow: hidden;
    min-height: 100%;
    padding: 110px 0 0;
    color: #000;
    letter-spacing: 0.1em;
    .container{
        min-height: 800px;
    }
    &.is_home{
        padding-top: 0;
    }
    @media screen and (max-width: 768px) {
        padding: 1.2rem 0 0;
        font-size: .24rem;
        .container{
            min-height: 9rem;
        }
    }
}
.form{
    .title{
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 36px;
        padding: 0 15px;
        .p2{
            font-size: 12px;
            font-weight: normal;
            color: #a5a5a5;
            margin-top: 5px;
        }
    }
    .input_group{
        display: flex;
        .input_wrap{
            flex: 1;
            margin-right: 10px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
    .btn{
        height: 35px;
        background: #000;
        font-size: 12px;
        color: #fff;
        text-align: center;
        line-height: 35px;
        margin: 30px 0 0;
        display: block;
        cursor: pointer;
        user-select: none;
        &.gray{
            background: #838383;
            pointer-events: none;
        }
    }
    .prompt{
        font-size: 12px;
        text-align: center;
        margin: 60px 0;
        span{
            border-bottom: 1px solid #000;
            cursor: pointer;
        }
        &.type2{
            margin: 30px 0 100px;
        }
    }
    .checkbox_wrap{
        display: flex;
        font-size: 12px;
        cursor: pointer;
        user-select: none;
        line-height: 1.5;
        .checkbox{
            width: 12px;
            height: 12px;
            border: 1px solid #000;
            margin: 3px 6px 0 0;
            flex-shrink: 0;
            position: relative;
            &.active{
                &::after{
                    width: 6px;
                    height: 6px;
                    background: #000;
                    content: "";
                    display: block;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        .title{
            font-size: .3rem;
            padding: 0;
            margin-bottom: .5rem;
            .p2{
                font-size: .22rem;
                margin-top: .1rem;
            }
        }
        .input_group{
            .input_wrap{
                margin-right: .2rem;
            }
        }
        .btn{
            width: 5.6rem;
            height: .8rem;
            margin: .8rem auto 0;
            font-size: .24rem;
            line-height: .8rem;
        }
        .prompt{
            font-size: .24rem;
            margin: .4rem 0 1.2rem;
            &.type2{
                margin: .3rem 0 1rem;
            }
        }
        .checkbox_wrap{
            font-size: .24rem;
            .checkbox{
                width: .2rem;
                height: .2rem;
                margin: .06rem .1rem 0 0;
                &.active{
                    &::after{
                        width: .1rem;
                        height: .1rem;
                    }
                }
            }
        }
    }
}
</style>
